import {
	type UseMutationOptions,
	useMutation,
	useQueryClient
} from '@tanstack/react-query'
import {
	type HttpUpdateOfferingMainPhoto,
	httpUpdateOfferingMainPhoto
} from '@/features/service-vetting/http/services-vetting.http.ts'
import { errorHandler } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'

export const useUpdateMainPhotoOffering = (
	urlParams: Omit<HttpUpdateOfferingMainPhoto['urlParams'], 'imgId'>,
	options?: UseMutationOptions<unknown, unknown, { imgId: number }>
) => {
	const queryClient = useQueryClient()
	return useMutation({
		...options,
		mutationFn: (payload) =>
			httpUpdateOfferingMainPhoto({
				urlParams: { ...urlParams, imgId: payload.imgId },
				params: {
					response_type: 'small'
				}
			}),
		onError: (error, variables, onMutateResult, context) => {
			errorHandler(error)
			options?.onError?.(error, variables, onMutateResult, context)
		},
		onSuccess: (data, variables, onMutateResult, context) => {
			queryClient.invalidateQueries({
				queryKey: [
					QUERY_KEYS.SERVICE_GALLERY_IMAGES,
					urlParams.serviceId
				]
			})
			queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.SERVICE_VETTING, urlParams.serviceId]
			})
			options?.onSuccess?.(data, variables, onMutateResult, context)
		}
	})
}
